import React from 'react';

const Input = ({
  type = 'text',
  label,
  error,
  success,
  placeholder,
  value,
  onChange,
  onBlur,
  required = false,
  disabled = false,
  className = '',
  ...props
}) => {
  const baseStyles = 'w-full px-4 py-2.5 bg-dark-lighter border rounded text-base text-light placeholder-light-muted/70 transition-all duration-300 focus:outline-none leading-normal';

  const stateStyles = error
    ? 'border-red-500 focus:border-red-500 focus:ring-2 focus:ring-red-500/50'
    : success
    ? 'border-green-500 focus:border-green-500 focus:ring-2 focus:ring-green-500/50'
    : 'border-dark-border focus:border-bronze focus:ring-2 focus:ring-bronze/50';

  return (
    <div className="w-full text-left">
      {label && (
        <label className="block text-sm font-semibold text-light mb-1.5 text-left">
          {label} {required && <span className="text-red-500 ml-0.5">*</span>}
        </label>
      )}

      <div className="relative">
        <input
          type={type}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          placeholder={placeholder}
          disabled={disabled}
          required={required}
          className={`${baseStyles} ${stateStyles} ${disabled ? 'opacity-60 cursor-not-allowed bg-dark-lighter/50' : ''} ${className}`}
          {...props}
        />

        {success && !error && (
          <div className="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none">
            <svg className="w-5 h-5 text-green-500" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
            </svg>
          </div>
        )}
      </div>

      {error && (
        <p className="mt-1.5 text-xs text-red-500 flex items-start">
          <svg className="w-4 h-4 mr-1 mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
          </svg>
          {error}
        </p>
      )}
    </div>
  );
};

export default Input;
